import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Button,
  Box,
} from "@mui/material"
import { ArrowRight } from "lucide-react"
import { NavLink } from "react-router-dom"

export function CurrentTasksWidget() {
  const tasks = [
    { id: 1, name: "Review Lease Agreement for 789 Pine St", status: "Pending", dueDate: "2024-07-18" },
    { id: 2, name: "Schedule Final Walkthrough: 101 Maple Ave", status: "Upcoming", dueDate: "2024-07-20" },
    { id: 3, name: "Submit Offer for Commercial Lot", status: "Overdue", dueDate: "2024-07-12" },
  ]

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Pending":
        return "#f97316" // orange-500
      case "Upcoming":
        return "#3b82f6" // blue-500
      case "Overdue":
        return "#ef4444" // red-500
      default:
        return "#6b7280" // muted foreground
    }
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ color: "#0d2561", fontWeight: 600 }}>
          Current Tasks
        </Typography>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ p: 2, fontWeight: 600 }}>Task</TableCell>
                <TableCell align="center" sx={{ p: 2, fontWeight: 600 }}>Status</TableCell>
                <TableCell align="right" sx={{ p: 2, fontWeight: 600 }}>Due Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((task) => (
                <TableRow
                  key={task.id}
                  hover
                  sx={{
                    borderBottom: "1px solid #e5e7eb", // similar to border-b
                    transition: "background 0.2s",
                    "&:hover": {
                      backgroundColor: "rgba(243, 244, 246, 0.5)", // hover:bg-muted/50
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      p: 2,
                      fontWeight: 500,
                      verticalAlign: "middle",
                    }}
                  >
                    {task.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      p: 2,
                      verticalAlign: "middle",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        color: getStatusColor(task.status),
                      }}
                    >
                      {task.status}
                    </span>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      p: 2,
                      verticalAlign: "middle",
                      fontSize: "0.875rem",
                      color: "#6b7280", // text-muted-foreground
                    }}
                  >
                    {new Date(task.dueDate).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box mt={2} textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: "#0d2561", textTransform: "none", fontSize: "0.875rem", p: 0, minHeight: "auto" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all tasks
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  )
}
